import {
  MDBAlert,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBCol,
  MDBDatatable,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSelect,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useNavigate } from 'react-router-dom';

import { Tooltip } from "react-tooltip";
import {
  fetchExistingPagingGroups,
  getAccountLevelPagingGroupsList,
  getDeviceOnlineStatusInfo,
  getSpesificAutoDeviceDetails,
  saveAutoDeviceSettings,
  sendZTPrequest,
  sendSyncRequest,
  getExistingOnly911Locations
} from "../apiclients/streamsapi_bridge.js";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";
import SaveChanges from "../components/topviews/saveCancel.js";
import AutoDeviceButtons from "./../components/topviews/phonesanddevices/AutoDeviceButtons.js";
import PopupLoader from "./popups/PopupLoader";
import AddDevices from "./popups/phonesystem/AddDevice";
import AddPagingGroupInAutoDeviceSettingsPopup from "./popups/phonesystem/AddPagingGroupInAutoDeviceSettingsPopup.js";
import { useAdminContext } from "../components/adminstore/Admin-Context.jsx";
import EditWarning from "../components/header/EditWarning.jsx";
import { customSearchFn } from "../components/CustomSearchUtil/CustomSearch.js";

function IpphonesAddDevice(props) {
  const [existinggrp, setExistinggrp] = useState([]);

  const [existPagingCount, setCount] = useState(0);
  const [autoDeviceDetails, setAutoDeviceDetails] = useState({});
  const [isEnabledSideCars, setIsEnabledSideCars] = useState(false);
  const [isEnabledPaging, setIsEnabledPaging] = useState(false);
  const [sel_data, setSelData] = useState([])
  const [isEnrolled, setIsEnrolled] = useState(true);
  const [isSidecarsErrorMessage, setSidecarsError] = useState("");
  const [formDefaultValues, setFormDefaultValues] = useState({
    settingsInfo: autoDeviceDetails,
    pagingGroupsData: {
      pagingGroups: sel_data,
    },
  });

  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const navigate = useNavigate();
  const [isError, setInternalError] = useState(false);
  const [pagingDisable, setpagingDisable] = useState(false);
  const passcodeRef = useRef(null);
  const [errorMessage, seterrorMessage] = useState(false);


  const {
    register,
    control,
    reset,
    formState: { dirtyFields, isDirty, errors },
    handleSubmit,
    setError,
    clearErrors,
    setValue,
    getValues,
  } = useForm({
    defaultValues: formDefaultValues,
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "pagingGroupsData.pagingGroups",
  });

  // Function to update settingsInfo default values
  const updateSettingsInfoDefault = (newSettingsInfo) => {
    setFormDefaultValues((prevValues) => ({
      ...prevValues,
      settingsInfo: newSettingsInfo,
    }));
  };

  const updatePagingGroupsDefault = (newPagingGroups) => {
    setFormDefaultValues((prevValues) => ({
      ...prevValues,
      pagingGroupsData: {
        ...prevValues.pagingGroupsData,
        pagingGroups: newPagingGroups,
      },
    }));
  };

  const location = useLocation();
  const combineData = location?.state ? JSON.parse(location?.state?.device) : {};
  const [preDeviceInfo, setPreDeviceInfo] = useState(combineData?.preDeviceInfo || "");
  const [nextDeviceInfo, setNextDeviceInfo] = useState(combineData?.nextDeviceInfo || "");
  const [deviceInfo, setDeviceInfo] = useState(combineData?.selMember || "");
  const [deviceListInfo, setDeviceListInfo] = useState(combineData?.deviceList || "");

  //const [deviceUUID, setDeviceUUID] = useState(location.state ? location.state.deviceUUID ? location.state.deviceUUID : "" : "");

  const [macAddress, setMacAdress] = useState(
    location.state
      ? location.state.macAdress
        ? location.state.macAdress
        : ""
      : ""
  );

  const [enableDisableSideCars, setEnableDisableSideCars] = useState(false);

  const [basicModal, setBasicModal] = useState(false);

  const [enablePaging, setEnablePaging] = useState(false);

  const toggleShow = () => setBasicModal(!basicModal);

  const [verticalActive, setVerticalActive] = useState("tab1");

  const [accountLevelPagingGroups, setAccountLevelPagingGroups] = useState([]);

  const [pagingGroupsListdata, setPagingGroupsListdata] = useState([]); // [{text: "Ganesh Paging", value: 1, groupId = 344 },{text: "Vamshi Paging", value: 2, groupId = 345 }]

  //const [pagingGroups, setPagingGroups] = useState([]);

  const [AddPagingGroup, setAddPagingGroup] = useState(false);


  const [showAddDevicePopup, setShowAddDevicePopup] = useState(false);

  const ToggleAddPagingGroup = () => setAddPagingGroup(!AddPagingGroup);

  const [onlineStatusInfo, setOnlineStatusInfo] = useState({
    macAddress: "",
    online_status: false,
    IpAddress: "",
  });

  const closePopup = () => {
    setShowAddDevicePopup(false);
  };

  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }
    setVerticalActive(value);
  };
  const [acdActive, setAcdActive] = useState("generalsettings");
  const [fillActive, setFillActive] = useState("tab1");
  const [updatesuccessMessage, setUpdateSuccessMessage] = useState("");
  const [showNoGroupAlert, setShowNoGroupAlert] = useState(false);


  const handleFillClick = (value) => {
    if (value === fillActive) {
      return;
    }

    setFillActive(value);
  };
  const handleAcdClick = (value) => {
    if (value === acdActive) {
      return;
    }
    if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }

    setAcdActive(value);
  };

  const handleOk = () => {
    setEdited(false);
    reset();
    if (targetView.indexOf("/") !== -1) {
      const targetValues = targetView.split("#")
      if (targetValues.length > 1) {
        navigate(targetValues[0],
          {
            state: { tab: targetValues[1] },
          }
        );

      } else {
        navigate(targetValues[0]);
      }

    } else {
      setAcdActive(targetView);
    }
    setShowWarning(false);
  };

  const [agent, setAgent] = useState("tab1");

  const handleAgentClick = (value) => {
    if (value === agent) {
      return;
    }

    setAgent(value);
  };
  const [ztpUpdate, setZtpUpdate] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [pagingGroupModal, setPagingGroupModal] = useState(false);
  const toggleShow2 = () => setPagingGroupModal(!pagingGroupModal);

  const [replaceDevice, setReplaceDevice] = useState(false);

  const toggleShow7 = () => setShowAddDevicePopup(!showAddDevicePopup);

  const [rowsInfo, setRowsInfo] = useState([]);
  const [locationsInfo, setLocationsInfo] = useState([]);
  const [isloading, setIsloading] = useState(false);

  const fetchAutoDeviceData = async (mac) => {
    console.log("in [fetchAutoDeviceData]" + mac);
    let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    let paramjo1 = {};
    paramjo1.siteid = siteid;
    paramjo1.macAdress = mac ? mac : macAddress;
    console.log(
      "sending parameters for api request :" + JSON.stringify(paramjo1)
    );
    setIsloading(true);
    let saverepData = await getSpesificAutoDeviceDetails(siteid, paramjo1);
    if (!saverepData.ok) {
      setTimeout(() => { setIsloading(false) }, 1000);
      console.log("Network response was not ok");
    } else {
      let saverepeMsg = await saverepData.json();
      let autoDeviceData = await saverepeMsg.autoDeviceData;
      //setDeviceData(manualDeviceData);
      console.log("response Data :" + JSON.stringify(autoDeviceData));
      console.log("macAddress  ::: " + autoDeviceData.macaddress);
      console.log("is_paging_enabled  ::: " + autoDeviceData.is_paging_enabled);
      setIsEnabledPaging(autoDeviceData.is_paging_enabled);

      // reset(manualDeviceData);
      //autoDeviceData.reqId = 79;
      setAutoDeviceDetails(autoDeviceData);
      console.log("is suported Paging " + autoDeviceData?.is_paging_support);
      setIsEnabledSideCars(autoDeviceData?.is_enabled_sidecars);
      console.log(
        "is_enabled_sidecars :::::::" + autoDeviceData?.is_enabled_sidecars
      );
      // setBackupData(linesList)
      // setIsloading(false)
      setTimeout(() => { setIsloading(false) }, 1000);
      // setValue("formdata", autoDeviceData);
      //reset(settingsInfo: autoDeviceData);
      // setValue("",autoDeviceData)
    }
  };

  /*  const columnsData = [
    { label: "Paging Group", field: "pagingGroup" },
    { label: "Group ID", field: "groupNo" },
    { label: "Send And Receive", field: "sendAndReceive" },
    { label: "Remove", field: "Remove" },
  ]; */

  const PagingGroupData = {
    columns: [
      { label: "Paging Group", field: "pagingGroup", sort: false },
      { label: "Group ID", field: "groupNo", sort: false },
      { label: "Send And Receive", field: "sendAndReceive", sort: false },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows: rowsInfo,
  };

  function PagingDisableContent(props) {
    return (
      <>

        <div className="d-flex align-items-center bg-warning bg-opacity-25 p-3  rounded-3 square border border-2 border-warning">
          <MDBIcon fas icon="ban" className="me-3" size="lg" color="warning" />
          <span>
            Disabling the paging groups option will also remove all associated paging groups from the phone. Do you want to proceed?
          </span>
        </div>
        <MDBModalFooter className='p-0 mt-3 pt-2'>
          <MDBBtn
            color="secondary"
            className="cancle-btn"
            onClick={props.onClose}
          >
            {t("close")}
          </MDBBtn>
          <MDBBtn
            onClick={() => {
              setIsEnabledPaging(!isEnabledPaging);
              setValue("settingsInfo.is_paging_enabled", !isEnabledPaging, { shouldDirty: true });
              setSelData([])
              remove()
              props.onClose();
            }}
          >
            {t("confirm")}
          </MDBBtn>
        </MDBModalFooter>

      </>
    );
  }

  const handleCheckboxChange = (e) => {
    try {
      if (!isEnabledPaging && pagingGroupsListdata.length === 0) {
        setShowNoGroupAlert(true);
        setTimeout(() => {
          setShowNoGroupAlert(false)
        }, 3000)
      } else {
        if (!e.target.checked && sel_data.length > 0) {
          setpagingDisable(!pagingDisable)
        } else {
          setIsEnabledPaging(!isEnabledPaging);
          setValue("settingsInfo.is_paging_enabled", !isEnabledPaging, { shouldDirty: true });
        }


        // setEnablePaging(!enablePaging); // Toggle the checkbox state
      }

    } catch (e) {
      console.log("Error::::::" + e);
    }
  };

  {
    /*After updating enablePaging value to true , will send Api Request to get PagingGrouplist associated with device  :Ganesh*/
  }
  useEffect(() => {
    console.log("useEffect Paging value:" + enablePaging);
    if (enablePaging) {
      //fetchExistPagingGroups()
      setValue("pagingGroupsData.pagingGroups", existinggrp);
      //addPagingGroupstoUI_interface();
    }
  }, [enablePaging]);

  const toggleSideCarsinputs = async (e) => {
    try {
      // setEnableDisableSideCars(!enableDisableSideCars); {/*depends on this field setting ,side car's UI options will display :Ganesh*/ }
      setIsEnabledSideCars(!isEnabledSideCars);
      // setFormDefaultValues((prevValues) => ({
      //   ...prevValues,shouldDirty: true,
      //   settingsInfo: {
      //     ...prevValues.settingsInfo,shouldDirty: true,
      //     is_enabled_sidecars: !isEnabledSideCars,shouldDirty: true
      //   },
      // }));
      setValue("settingsInfo.is_enabled_sidecars", !isEnabledSideCars, { shouldDirty: true });

    } catch (e) {
      console.error("[ipPhonesAddDevice.js][toggleSideCarsinputs] :" + e);
    }
  };

  const passcodeInput = (value) => {
    try {
      const consecutive = "0123456789";
      const reverseConsecutive = "9876543210";

      console.log("request came to passcodeInput  " + value);
      if (value == undefined || value == null || value == '') {
        setValue("settingsInfo.passcode", "", { shouldDirty: true });
        setError("settingsInfo.passcode", { type: "EmptyError", message: "Passcode is required" });
      } else if (value.toString().startsWith(0)) {
        setError("settingsInfo.passcode", { type: "EmptyError", message: "Passcode should not start with zero (0)" });
      } else if (consecutive.includes(value) || reverseConsecutive.includes(value)) {
        setError("settingsInfo.passcode", { type: "EmptyError", message: "Passcode should not contain consecutive numbers." });
      }
      else if (value.length < 5) {
        setError("settingsInfo.passcode", { type: "EmptyError", message: "Passcode length must be between 5 and 6 digits." });
      } else {
        clearErrors("settingsInfo.passcode");
        setValue("settingsInfo.passcode", value, { shouldDirty: true });
      }
    } catch (e) {
      console.error("[ipPhonesAddDevice.js][passcodeInput] :" + e);
    }
  };

  const fetchAccountLevelPagingGropups = async () => {
    console.log(" Making Fetch Api Request to get AccountLevelPagingGropups :");
    let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    let serverResponse = await getAccountLevelPagingGroupsList(siteid);
    if (!serverResponse.ok) {
      console.log("Network response was not ok");
      throw new Error("Network response was not ok");
    } else {
      let responseData = await serverResponse.json();
      let apiData = await responseData.paging_groups_list;
      console.log(
        "AccountLevelPagingGropups from node Server response : " +
        JSON.stringify(apiData)
      );
      setPagingGroupsListdata(apiData);
    }
  };
  useEffect(() => {
    console.log("sel_data", sel_data);
  }, [sel_data]);

  useEffect(() => {
    setSelData(existinggrp); // Update sel_data whenever existinggrp changes
  }, [existinggrp]);

  const fetchExistPagingGroups = async (mac) => {
    try {
      console.log(" Making Fetch Api Request to get fetchExistPagingGroups :");
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      var params = {};
      params.phonemac_id = autoDeviceDetails.phonemacId == "" ? mac : autoDeviceDetails.phonemacId;
      let serverResponse = await fetchExistingPagingGroups(siteid, params);
      if (!serverResponse.ok) {
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        let respData = await serverResponse.json();
        let existPagingList = respData.existingDevicePagingGroupList;
        console.log(
          "Recieved existPagingList :" + JSON.stringify(existPagingList)
        );
        setExistinggrp(existPagingList);
        if (existPagingList?.length > 0) {
          setEnablePaging(true);
        }
        setValue("pagingGroupsData.pagingGroups", existPagingList);
        setCount(existPagingList.length);
      }
      //let existPagingList = [{ "pagingGroup": "Group123", "groupID": 1, "sendAndReceive": 3, "phonemacId": 389 }, { "pagingGroup": "vamshi", "groupID": 1, "sendAndReceive": 3, "phonemacId": 389 }]
    } catch (e) {
      console.error("Error in [fetchExistPagingGroups] " + e);
    }
  };
  const handleEnrollmentToggle = async (e, type, macaddress, devicename) => {
    // Toggle type dynamically
    const jsonObj = { type, macaddress: macaddress, devicename };
    console.log("Sending Request:", JSON.stringify(jsonObj));
    try {
      const siteId = JSON.parse(sessionStorage.getItem("admin_session"))?.siteid;
      const response = await sendZTPrequest(siteId, jsonObj);
      console.log("response :::: " + response);
      let saverepeMsg = await response.json();
      if (!response.ok) {
        console.log("Network response was not ok handleEnroll handleEnrollmentToggle ");
        setInternalError(true);
        seterrorMessage(saverepeMsg.message)
        setZtpUpdate(!ztpUpdate)
        setTimeout(() =>{
          setInternalError(false);
        }, 3000);
        throw new Error("Network response was not ok");
      } else {
        console.log(saverepeMsg)
        if (saverepeMsg.status == "success") {
          setIsEnrolled(!isEnrolled);
          localStorage.setItem("s_message", "Enrolled successfully. Please reboot the device.");
          setZtpUpdate(!ztpUpdate)
          navigate(0)

        }
      }
    } catch (error) {
      console.log("Network response was not ok [handleEnrollmentToggle] [sendZTPrequest] " + error);
    }
  };
  const handleSyncRequestToggle = async (e, deviceUUID) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.classList.add("rotateSyncIcon")
    if (!deviceUUID) {
      console.error("Device UUID is missing for sync request.");
      return;
    }
    try {
      const jsonObj = {
        devices: [deviceUUID]
      };
      console.log("Sending Sync Request:", JSON.stringify(jsonObj));
      setIsloading(true)
      const response = await sendSyncRequest(jsonObj);
      let responseData = await response.json();
      if (responseData?.status == 200) {
        setIsloading(false)
        setUpdateSuccessMessage("Sync completed successfully!");
        setTimeout(() => {
          setUpdateSuccessMessage(""); // Clear the success message 
        }, 2000);
      } else {
        console.error("Sync request failed with error:", responseData.error);
        setInternalError(true);
        setTimeout(() => {
          setIsloading(false)
          setInternalError(false);
        }, 2000);
        throw new Error("Sync request failed");
      }

    } catch (error) {
      console.log("Network response was not ok [handleSyncRequestToggle] [sendSyncRequest] " + error);
    }

    setTimeout(() => {
      e.target.classList.remove("rotateSyncIcon")
    }, 1000)
  };

  const fetchDeviceOnlineStatus = async () => {
    console.log("Making requets to fetch DeviceOnlineStatus ");

    try {
      let macAddress = [];
      macAddress.push(autoDeviceDetails.macaddress);
      var paramsJo = {
        deviceUUID: autoDeviceDetails.device_uuid,
        userid: autoDeviceDetails.agentId,
        macAddresList: macAddress,
      };
      console.log("praramJO:::::::::" + JSON.stringify(paramsJo));

      let api_response = await getDeviceOnlineStatusInfo(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        paramsJo
      );

      if (!api_response.ok) {
        console.log("Network response was not ok for fetchDeviceOnlineStatus ");
      } else {
        console.log("request Succes for  fetchDeviceOnlineStatus  ");

        let apires = await api_response.json();

        console.log("Response recieved for fetchDeviceOnlineStatus:  " + JSON.stringify(apires.deviceStatus));
        const updatedOnlineStatusInfo = apires.deviceStatus.map((device) => ({
          macAddress: device?.macaddress || "",
          online_status: device?.online_status || false,
          IpAddress: device?.IpAddress.replace("sip:", "").split(":")[0] || "",
        }));
        // [{"macaddress":"POLYPM89013","online_status":true,"IpAddress":"sip:44.55.66.77:5062"}]
        console.log("updatedOnlineStatusInfo ::::::: " + JSON.stringify(updatedOnlineStatusInfo));
        setOnlineStatusInfo(updatedOnlineStatusInfo);
        console.log("online status ::: " + JSON.stringify(onlineStatusInfo)); //liveDeviceInfo = {device_uuid:"e7f9348f-9cf4-486a-9aa3-76516893363c",online_status:true}
      }
    } catch (e) {
      console.log("Error in fetchDeviceOnlineStatus :" + e);
    }
  };
  async function getLocationsList() {
    try {
      let locationsList = await getExistingOnly911Locations(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      if (!locationsList.ok) {
        console.log("got an issue whie");
        // throw new Error("Network response was not ok");
      } else {
        let responseData = await locationsList.json();
        console.log("getExistingOnly911Locations responseData  " + JSON.stringify(responseData)
        );
        if (responseData.status == "success") {
          const finalList = responseData.nineoolocations.map((item) => {
            return {
              value: item.nineoo_loc_id,
              text: item.nineoo_loc_name,
            };
          });
          finalList.unshift({ text: "Select 911 Location", value: "" });
          console.log("911finalList :: " + JSON.stringify(finalList));
          setLocationsInfo(finalList);
        }
      }

    } catch (error) {
      console.error("Error:", error);
    }
  }

  const handleLocation = (item) => {
    setValue(`settingsInfo.profileId`, item, {
      shouldDirty: true,
    });
    // setValue("settingsInfo.location", newValue, { shouldDirty: true });
  };
  useEffect(() => {
    console.log("Request came ::::::::::here " + JSON.stringify(fields));
    addPagingGroupstoUI_interface();
  }, [sel_data,pagingGroupsListdata,fields]);

  // Use useEffect to watch for changes in autoDeviceDetails and existinggrp
  useEffect(() => {
    updateSettingsInfoDefault(autoDeviceDetails);
    if (autoDeviceDetails?.phonemacId) {
      fetchExistPagingGroups(autoDeviceDetails?.phonemacId);
    }
  }, [autoDeviceDetails]);

  useEffect(() => {
    if (autoDeviceDetails?.device_uuid) {
      fetchDeviceOnlineStatus();
    }
  }, [autoDeviceDetails]);

  useEffect(() => {
    updatePagingGroupsDefault(existinggrp);
  }, [existinggrp]);

  // Later when you need to reset the form with updated defaults:
  useEffect(() => {
    // Reset the form with updated default values
    reset(formDefaultValues);
  }, [formDefaultValues, reset]);

  var PagingOptions = false;
  const handle_onclick = () => {
    console.log("request reached to handle_onclick");
    PagingOptions = !PagingOptions;
    console.log(" Request :" + PagingOptions);
  };
  const handleSelectChange = (index) => (e) => {
    const selectedValue = e.target.value;
    console.log("sell", index, e.target.value)
    setValue(`pagingGroupsData.pagingGroups[${index}].paging_group`, selectedValue)
    const pagingId = e.target.options[e.target.selectedIndex].getAttribute("pagingid");
    const groupNo = e.target.options[e.target.selectedIndex].getAttribute("groupNo");
    console.log(`value selected: ${selectedValue} groupno: ${groupNo}`);
    const updated = sel_data.map((ee, i) =>
      i === index ? { ...ee, paging_group: selectedValue, paging_id: pagingId, group_no: groupNo } : ee
    );
    console.log("updated sel_data", updated);
    setSelData(updated)
    setValue(
      `pagingGroupsData.pagingGroups[${index}].group_no`,
      groupNo,
      { shouldDirty: true }
    );
    setValue(
      `pagingGroupsData.pagingGroups[${index}].send_and_recieve`,
      "3",
      { shouldDirty: true }
    );
    setValue(
      `pagingGroupsData.pagingGroups[${index}].paging_id`, pagingId,
      { shouldDirty: true }
    );
  };
  const addPagingGroupstoUI_interface = () => {
    console.log("started :::: ")
    console.dir(pagingGroupsListdata);
    console.log("pagingGroupsListdata ::: ", pagingGroupsListdata);

    const array = [];
    const exist_group = sel_data.map((e) => e.paging_group);
    console.log("exist_group :::", exist_group);
    console.log("fields :: ", fields)
    console.log("sel_data :: ", sel_data)
    console.log("fields :::", fields);

    console.log("addPagingGroupstoUI_interface :" + JSON.stringify(fields));
    fields.map((element, index) => {
      console.log("element" + element.value + " index" + index);
      console.dir(element);
      const available_groups = sel_data.filter((e, i) => i !== index).map((e) => e.paging_group)
      console.log("available_groups :: ", available_groups)
      //console.log("selecting value: " + existinggrp[index].groupName);
      array.push({
        pagingGroup: (
          <select
            className="form-control form-select selectname"
            key={element.id}
            {...register(
              `pagingGroupsData.pagingGroups[${index}].paging_group`
            )}
            onChange={handleSelectChange(index)}
          >
            {pagingGroupsListdata.map((data) => (
              !available_groups.includes(data.group_name) && <option
                value={data.group_name}
                groupName={data.group_name}
                groupNo={data.group_no}
                pagingid={data.paging_id}
              >
                {data.group_name}
              </option>
            ))}
          </select>
        ),
        groupNo: (
          <input
            type="text"
            className="form-small-s"
            name={`pagingGroupsData.pagingGroups[${index}].group_no`}
            key={element.id}
            readOnly
            {...register(`pagingGroupsData.pagingGroups[${index}].group_no`)}
          />
        ),
        sendAndReceive: (
          <select className="form-control form-select selectname"
            {...register(
              `pagingGroupsData.pagingGroups[${index}].send_and_recieve`
            )}
            name={`pagingGroupsData.pagingGroups[${index}].send_and_recieve`}
            onChange={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setValue(
                `pagingGroupsData.pagingGroups[${index}].send_and_recieve`,
                e.target.value,
                { shouldDirty: true }
              );
            }}
          >
            <option value="1">Send</option>
            <option value="2">Receive</option>
            <option value="3">Both</option>
          </select>
        ),
        delete: (
          <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const filterData = sel_data.filter((e, i) => i !== index);
              console.log("filterData :: ", filterData)
              setSelData(filterData)
              remove(index);
            }}>
            <MDBIcon
              title="Remove"
              fas
              icon="times"
              className="cursor-pointer"
            />
          </div>

        ),
      });
    });
    setRowsInfo(array);
  };
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const mac = urlParams.get('mac_address');
    if (mac) {
      setMacAdress(mac);
    }
    fetchAutoDeviceData(mac);
    fetchAccountLevelPagingGropups();
    getLocationsList();
  }, [ztpUpdate]);

  function onCloseChanges() {
    console.log("reset changes::::::::::::::::::::::::::");
    // reset({ settingsInfo: autoDeviceDetails });
    setSidecarsError("");
    setIsEnabledPaging(autoDeviceDetails.is_paging_enabled);
    setIsEnabledSideCars(autoDeviceDetails?.is_enabled_sidecars);
    // reset({ pagingGroupsData: { pagingGroups: existinggrp } });
    setSelData(existinggrp)
    reset(formDefaultValues);
    passcodeRef.current.value = autoDeviceDetails.passcode
  }

  const onsaveChanges = (formdata) => {
    try {
      console.log("save changes::::::::::::::::::::::::::");
      console.dir(formdata);
      console.log("[ipPhonesAddDevice.js] Making server request to submit ");
      if (isDirty) {
        console.log("[ipPhonesAddDevice.js] Dirty Fields :::" + JSON.stringify(dirtyFields));
      }
    } catch (e) {
      console.error(
        "[ipPhonesAddDevice.js] Error while making server request " + e
      );
    }
  };

  useEffect(() => {
    setEdited(isDirty);

  }, [isDirty])

  const onSubmit = async (data) => {

    console.log("Saving changes:", data);
    // Proceed with save logic here

    // async request which may result error
    console.log("mac onSubmit ")
    try {
      // await fetch()
      console.dir(data);
      //console.log("dirty::::::::::" + formState.dirtyFields);
      console.log("[ipPhonesAddDevice.js] Dirty Fields :::" + JSON.stringify(dirtyFields));

      if (isDirty) {
        console.log("[ipPhonesAddDevice.js] Dirty Fields :::" + JSON.stringify(dirtyFields));
        const inputParams = frameParams(data);
        console.log("request arameters :" + JSON.stringify(inputParams));
        let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        // inputParams.reqid = 32;
        inputParams.device_uuid = autoDeviceDetails?.device_uuid
        inputParams.deviceName = autoDeviceDetails?.devicename;
        inputParams.mac_address = macAddress;
        inputParams.phonemacid = autoDeviceDetails.phonemacId;
        inputParams.noofsidecarsadded = !isEnabledSideCars ? 0 : data.settingsInfo.noofsidecarsadded;
        inputParams.formfields.sidecarmodeltype = !isEnabledSideCars ? 0 : data.settingsInfo.sidecarmodeltype;//autoDeviceDetails.sidecarmodeltype;
        inputParams.ipphonetype_id = autoDeviceDetails.ipphonetype_id;
        inputParams.is_paging_enabled = autoDeviceDetails.is_paging_enabled;
        inputParams.pagingCount = existPagingCount;
        console.log("params data: " + JSON.stringify(inputParams));
        //return;
        const ServerRequest = await saveAutoDeviceSettings(siteid, inputParams);
        const saverepeMsg = await ServerRequest.json();

        if (!ServerRequest.ok || saverepeMsg.status === "failed") {
          console.log("Network response was not ok");
          if (saverepeMsg?.message != "") {
            setError("settingsInfo.sidecarmodeltype", { type: "serverResponse", message: saverepeMsg?.message });
          }
          onCloseChanges()
          setInternalError(true);
          setTimeout(() => {
            setInternalError(false);
            window.location.reload();
          }, 500);

          // throw new Error("Network response was not ok");
        } else {
          localStorage.setItem("s_message", `updated successfully. Please reboot the device.`);
          window.location.reload();
          console.log("Server response is success :");
          fetchAutoDeviceData();
          if (saverepeMsg?.passcodeErrorMessageInfo != "") {
            console.log("serverResponse setting passcode error message");
            setTimeout(() => {
              setError("settingsInfo.passcode", { type: "serverResponse", message: saverepeMsg?.passcodeErrorMessageInfo });
            }, 300);
          }
        }
      }
    } catch (e) {
      // handle your error
      console.log("error " + e);
    }
  };
  function ShowPagingDisablePopup(props) {
    console.log("[ShowPagingDisablePopup] " + props);
    const { t, i18n } = useTranslation();
    var propsData = props.paramJo;
    return (
      <>
        <PopupLoader
          title={
            "Alert"
          }
          content={
            <PagingDisableContent
              onClose={props.onclosepopup}
            />
          }
          // className={"popup-width"}
          // onShow={props.setshow}
          onClose={props.onclosepopup}
        />
      </>
    );
  }

  const frameParams = (formdata) => {
    console.log("[IpPhonesAddDevice.js] frame prams: " + JSON.stringify(formdata));

    try {
      var formFields = {};
      console.log("Dirty Fields :::" + JSON.stringify(dirtyFields));

      let settingsinfo_dirtyFields = dirtyFields?.settingsInfo ?? {};

      if (Object.keys(settingsinfo_dirtyFields).length > 0) {
        Object.keys(settingsinfo_dirtyFields).map((key) => {
          if (settingsinfo_dirtyFields[key] && key != "sideCarTypes") {
            formFields[key] = formdata.settingsInfo[key];
          }
        });
      }

      console.log("formFields:   ", JSON.stringify(formFields));

      let pagingGroupsData = [];

      var formDataPagingGroups = formdata?.pagingGroupsData?.pagingGroups ?? [];

      console.log("formDataPagingGroups :", formDataPagingGroups);

      formDataPagingGroups.sort((a,b)=>a.group_no - b.group_no).map((elment) => {
        console.log("elment=> ", elment);
        pagingGroupsData.push({
          send_recieve: elment.send_and_recieve,
          paging_id: elment.paging_id,
          paging_group: elment.paging_group,
          paging_group_no: elment.group_no,
        });
      });

      var jo = {};
      jo.formfields = formFields;
      if (dirtyFields?.pagingGroupsData) {
        jo.pagingGroups = pagingGroupsData;
      }
      return jo;
    } catch (e) {
      console.log("Error in [ManualDeviceSettings.js][frameParams] :" + e);
    }
  };

  const AddPagingGroupsRequest = async (jsonParams) => {
    try {
      console.log("AddPagingGroupsRequest :" + JSON.stringify(jsonParams));
      const newData = {
        paging_group: jsonParams.group_name,
        group_no: jsonParams.group_no + "",
        send_and_recieve: jsonParams.send_receive,
        paging_id: jsonParams.paging_id + "",
      }
      setSelData([...sel_data, newData])
      append({
        paging_group: jsonParams.group_name,
        group_no: jsonParams.group_no + "",
        send_and_recieve: jsonParams.send_receive,
        paging_id: jsonParams.paging_id + "",
      });

      //setValue('pagingGroups', fields);

      // Reset fields to pristine after append
      // setTimeout(() => {
      //   setValue('pagingGroups', fields);
      // });
      //setValue('pagingGroups', fields);

      // jsonParams.phonemac_id = autoDeviceDetails.phonemacId;
      // let serverResponse = await AddPagingGroupInDeviceSettings(JSON.parse(sessionStorage.getItem("admin_session")).siteid, jsonParams);
      // if (!serverResponse.ok) {
      //   console.log("Recieved Response :");
      // } else {
      //   console.log("Server Response not ok ");
      //   fetchExistPagingGroups();
      // }
      ToggleAddPagingGroup();
    } catch (e) {
      console.log("Error in AddPagingGroupsRequest" + e);
    }
  };
  const sidecarsValidation = (value) => {
    if (value >= 0 && value <= autoDeviceDetails?.maxsidecarno) {
      return true; // Valid
    } else {
      return false;
    }
  };
  const handleNavigation = () => {
    if (isEdited) {
      setTargetView("/pslanding#tab2");
      setShowWarning(true);
      return;
    }
    navigate("/pslanding", {
      state: { tab: "tab2" },
    });
  };

  const section1 = useRef(null);
  const section2 = useRef(null);
  const containerRef = useRef(null);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll('.nav-link');
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
      const stickyParent = lastLink.closest('.sticky-top');
      if (stickyParent && lastLink.classList.contains('active')) {
        lastLink.classList.remove('active');
        for (let i = 0; i < scrollspyLinks.length; i++) {
          const firstLink = scrollspyLinks[i];
          const parent = firstLink.closest('.sticky-top');
          if (parent) {
            firstLink.classList.add('active');
            break;
          }
        }
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);


  const [time, setTime] = useState(10000); // Time in seconds

  useEffect(() => {
    // If the time reaches 0, stop the timer
    if (time <= 0) return;

    // Update the time every second
    const interval = setInterval(() => {
      setTime((prevTime) => prevTime - 1);
    }, 1000);

    // Clear the interval when the component unmounts or when the timer hits zero
    return () => clearInterval(interval);
  }, [time]); // Re-run effect when time changes

  // Convert the time from seconds to hh:mm:ss
  const hours = String(Math.floor(time / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((time % 3600) / 60)).padStart(2, '0');
  const seconds = String(time % 60).padStart(2, '0');

  // Helper function to split digits into an array
  const splitDigits = (timeString) => {
    return timeString.split('');
  };

  const modifytheState = (e, deviceInfo) => {
    e.preventDefault();
    const provisioningMethod = deviceInfo.provisioning_method * 1
    let selMember = provisioningMethod == 1 ? deviceInfo.MacAddress : deviceInfo.deviceUUID;
    const currentIndex = deviceListInfo.findIndex((tmdata) => provisioningMethod == 1 ? tmdata.MacAddress == selMember : tmdata.deviceUUID == selMember);
    const preDeviceInfo = currentIndex > 0 ? deviceListInfo[currentIndex - 1] : null;
    const nextDeviceInfo = currentIndex < deviceListInfo.length - 1 ? deviceListInfo[currentIndex + 1] : null;
    setDeviceInfo(selMember);
    setPreDeviceInfo(preDeviceInfo);
    setNextDeviceInfo(nextDeviceInfo);
    if (provisioningMethod == 1) {
      setMacAdress(selMember);
      fetchAutoDeviceData(selMember)
      fetchAccountLevelPagingGropups();
      getLocationsList();
    } else {
      const combinedData = {
        selMember,
        preDeviceInfo,
        nextDeviceInfo,
        deviceList: deviceListInfo
      }
      navigate("/manualdevicesettings", {
        state: {
          deviceUUID: selMember, device: JSON.stringify(combinedData)
        },
      });
    }
  };

  // // Check if the device is eligible for enrollment
  // const isEligibleForEnrollment =
  // autoDeviceDetails?.devicename?.includes("Polycom") || autoDeviceDetails?.devicename?.includes("Yealink");

  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={10}
          content={
            <>
              <section>
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/phonenumbers");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/phonenumbers");
                            }} >
                            <strong>{t("phoneSystem")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a onClick={handleNavigation}>
                            <strong>{t("IPPhonesDevice")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="">
                            <strong>
                              {" "}
                              {autoDeviceDetails.userName}{" "}
                              {autoDeviceDetails.designation}
                            </strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                      {
                        Object.keys(combineData).length > 0 && <div className="headerbtns">
                          <div className="customtooltip">
                            <MDBBtn
                              size="sm"
                              color="transparent"
                              className={preDeviceInfo != null ? "ms-2 " : "ms-2"}
                              disabled={preDeviceInfo == null || preDeviceInfo === ""}
                              onClick={(e) => modifytheState(e, preDeviceInfo)}
                            >
                              <i className="fa fa-chevron-left"></i>
                            </MDBBtn>
                            {preDeviceInfo != null && preDeviceInfo !== "" && (
                              <span className="tooltiptext">
                                Previous:
                                <br />
                                {preDeviceInfo != null
                                  ? preDeviceInfo.PhoneName
                                  : ""}
                              </span>
                            )}
                          </div>
                          <div className="customtooltip">
                            <MDBBtn
                              size="sm"
                              color="transparent"
                              className={
                                nextDeviceInfo != null
                                  ? "ms-2 active"
                                  : "ms-2 active"
                              }
                              disabled={
                                nextDeviceInfo == null || nextDeviceInfo === ""
                              }
                              onClick={(e) =>
                                modifytheState(e, nextDeviceInfo)
                              }
                            >
                              <i className="fa fa-chevron-right"></i>
                            </MDBBtn>
                            {nextDeviceInfo != null && nextDeviceInfo !== "" && (
                              <span className="tooltiptext">
                                Next:
                                <br />
                                {nextDeviceInfo != null
                                  ? nextDeviceInfo.PhoneName
                                  : ""}
                              </span>
                            )}
                          </div>
                        </div>
                      }
                    </h5>
                  </div>

                  <div className="card-body px-0">
                    <div className="mt-2 d-flex w-100 justify-content-between ipphone_column mb-3">
                      <div className="pb-2">
                        <h5 className="fw-600 mt-2 ">{autoDeviceDetails.userName}</h5>
                        <p className="mt-1 text-secondary">
                          {autoDeviceDetails.designation}
                        </p>
                        <p className="mt-1 text-secondary">
                          {autoDeviceDetails.devicename}
                        </p>
                        <p className="mt-1   text-secondary">
                          {autoDeviceDetails.phonename} :{" "}
                          {autoDeviceDetails.macaddress}
                        </p>
                      </div>

                      <div className="mt-2 d-flex w-50__btnalign  justify-content-around ipphone_column ">
                        <div className="d-flex flex-column align-items-center ip_column">
                          <strong className="">{t("Online")}</strong>
                          <span
                            className={
                              onlineStatusInfo[0]?.online_status
                                ? "green-dot mt-2"
                                : "red-dot mt-2"
                            }
                          ></span>
                        </div>
                        <div className="d-flex flex-column align-items-center ip_column">
                          <strong className="">{t("IPAddress")}</strong>
                          <span className="mt-1">
                            {onlineStatusInfo[0]?.IpAddress}
                          </span>
                        </div>
                        <div className="d-flex flex-column align-items-center ip_column">
                          <strong>{t("ZeroTouchStatus")}</strong>
                          {autoDeviceDetails.zeroTouchStatus == 1 ? (
                            <span className="mt-2 green-dot ZeroTouchRow"></span>
                          ) : (
                            <a className="text-center color-primary text-decoration-underline"
                              onClick={(e) => handleEnrollmentToggle(e, "enroll", autoDeviceDetails.macaddress, autoDeviceDetails.devicename)}
                            >
                              Enroll
                            </a>
                          )}
                        </div>
                        <div className="d-flex flex-column align-items-center ip_column">
                          <strong className="">{t("SyncConfig")}</strong>
                          {/* <img
                            src={syncIcon}
                            className="syncIcon cursor-pointer mt-1"
                            alt="Sync Icon"
                          ></img> */}

                          <MDBIcon fas icon="sync-alt" color="primary" className="fs-5 cursor-pointer mt-1"
                            onClick={(e) => handleSyncRequestToggle(e, autoDeviceDetails.device_uuid)}
                          />
                        </div>
                        <div className="d-flex flex-column justify-content-top align-items-center mt-2">

                          <div className="position-relative ip_replace_button">
                            <MDBBtn
                              className="reload-replace-btn reload-replace-icon ip_w100pr"
                              onClick={toggleShow7}
                            >
                              <span className="reload-replace ip_icon"></span>
                              <span> {t("replaceDevice")}</span>
                            </MDBBtn>
                            {/* <MDBBtn>End Hot Desk</MDBBtn> */}
                          </div>

                          {/* <div className="hotdeskTimer">
                            <div className="timeHrs">
                              <p className="me-1">Hours</p>
                              <div className="d-flex">
                                {splitDigits(hours).map((digit, index) => (
                                  <div key={`hour-${index}`} className="timeText me-1">
                                    {digit}
                                  </div>
                                ))}
                              </div>
                            </div>
                            <div className="me-1"></div>
                            <div className="timeMin">
                              <p className="me-1">Minutes</p>
                              <div className="d-flex">
                                {splitDigits(minutes).map((digit, index) => (
                                  <div key={`minute-${index}`} className="timeText me-1">
                                    {digit}
                                  </div>
                                ))}
                              </div>

                            </div>
                            <div className="me-1"></div>
                            <div className="timeSec">

                              <p className="me-1">Seconds</p>
                              <div className="d-flex">
                                {splitDigits(seconds).map((digit, index) => (
                                  <div key={`second-${index}`} className="timeText me-1">
                                    {digit}
                                  </div>
                                ))}
                              </div>

                            </div>
                          </div>

                          <p className="mt-2 hotdesklabel">Hot Desk Timeout</p> */}


                        </div>

                      </div>
                    </div>

                    <MDBTabs>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleAcdClick("generalsettings")}
                          active={acdActive === "generalsettings"}
                        >
                          {t("settings")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleAcdClick("bulkloginlogout")}
                          active={acdActive === "bulkloginlogout"}
                        >
                          {t("buttons")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>
                    <MDBTabsContent>
                      <MDBTabsPane open={acdActive === "generalsettings"}>
                        {/* General Settings content */}
                        <div className="row mt-3">
                          <MDBCol
                            size="2"
                            md="2"
                            lg="2"
                            sm="12"
                            className="col-sm-100 pr-0 leftTabs"
                          >
                            <MDBScrollspy container={containerRef} offset={500}>
                              <MDBScrollspyLink targetRef={section1} >{t("general")}</MDBScrollspyLink>
                              <MDBScrollspyLink targetRef={section2} >{t("emergency911")}</MDBScrollspyLink>
                            </MDBScrollspy>
                          </MDBCol>

                          <MDBCol
                            size="12"
                            md="10"
                            sm="12"
                            pr-0
                            className="col-sm-100 pr-0 leftTabContent"
                          >
                            <div class="vtabHeight pr-5">



                              <div id='element' ref={containerRef} className='scrollspy-example'>
                                <section ref={section1} id='section-1'>



                                  <div className="card-header py-0 px-0" id="general">
                                    <div class="general-settings">
                                      {t("general")}
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div className="tel-numbers">
                                      {t("phoneName")}
                                    </div>
                                    <div className="d-flex w-30">
                                      <div className="phoneselect w-100">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name={`settingsInfo.phonename`}
                                          onKeyDown={(event) => {
                                            if (!/[a-zA-Z0-9 _]/.test(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          {...register("settingsInfo.phonename", {
                                            required: {
                                              value: true,
                                              message: "phoneName canot be empty",
                                            },
                                          })}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div>
                                      <div>
                                        {t("userLocation")}
                                      </div>
                                      <span className="phrecording">
                                        Location Of The Phone's User is Assigned To,
                                        User For Filtering The Location
                                      </span>
                                    </div>
                                    <div className="d-flex w-30">
                                      <div className="phoneselect w-100">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name={`settingsInfo.address`}
                                          {...register("settingsInfo.address", {
                                            required: {
                                              value: false,
                                              message: "Location canot be empty",
                                            },
                                          })}
                                          disabled={true}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="add-numbermain">
                                    <div>
                                      <div>
                                        {t("passcode")}
                                      </div>
                                      <span className="phrecording">
                                        {t("passcodetxt")}
                                      </span>
                                    </div>
                                    <div className="d-flex w-30">
                                      <div className="phoneselect w-100">
                                        <input
                                          type="text"
                                          className="form-control"
                                          defaultValue={autoDeviceDetails.passcode}
                                          placeholder="Enter a 6-digit passcode"
                                          maxLength={6} // Restrict length to 6
                                          onKeyDown={(event) => {
                                            if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete') {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(e) => {
                                            const value = e.target.value.replace(/[^0-9]/g, '');
                                            passcodeInput(value);
                                          }}
                                          ref={passcodeRef}

                                        />
                                      </div>
                                    </div>
                                  </div>
                                  {errors.settingsInfo?.passcode && (
                                    <p className="text-danger text-end pe-3">
                                      {errors.settingsInfo.passcode.message}
                                    </p>
                                  )}
                                  {autoDeviceDetails?.maxsidecarno > 0 && (
                                    <div className="add-numbermain">
                                      <div>
                                        <div>{t("EnableSideCars")}</div>
                                        <span className="phrecording">{t("EnableSideCarstxt")}</span>
                                      </div>
                                      <div className="d-flex">
                                        <div className="phoneselect">
                                          <label className="switch">
                                            <input
                                              className="form-control"
                                              type="checkbox"
                                              name="enableSidecars"
                                              checked={isEnabledSideCars}
                                              onChange={toggleSideCarsinputs}
                                            />
                                            <span className="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {/*enableDisableSideCars contains true or false Boolean values it will show hide UI fields under sidecar's  */}
                                  {isEnabledSideCars && autoDeviceDetails.maxsidecarno > 0 &&
                                    <>
                                      <div className="add-numbermain pb-0">
                                        <div >
                                          {t("SideCarType")}
                                        </div>
                                        <div className="d-flex w-30">
                                          {/* below code will show selctbox in ui if sidecartypes available , else will show input box with N/A  :   Ganesh  */}
                                          {/*"sideCarTypes":[{"text":"VVX Color Module","value":1},{"text":"VVX Expansion Module","value":2}] */}

                                          <div className="phoneselect w-100">
                                            {autoDeviceDetails?.sideCarTypes?.length >= 1 ? (
                                              <select
                                                className={`form-control form-select w-100 ${errors.settingsInfo?.sidecarmodeltype ? "" : ""}`}
                                                defaultValue={autoDeviceDetails?.sidecarmodeltype || "0"}
                                                {...register("settingsInfo.sidecarmodeltype", {
                                                  required: "Please choose a valid side car type.",
                                                  validate: (value) => value !== "0" || "Please choose a valid side car type.",
                                                })}
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  setValue("settingsInfo.sidecarmodeltype", value, {
                                                    shouldDirty: true,
                                                  });
                                                  if (value !== "0") {
                                                    clearErrors("settingsInfo.sidecarmodeltype");
                                                  }
                                                }}
                                              >
                                                <option key="0" value="0">
                                                  Choose your option
                                                </option>
                                                {autoDeviceDetails?.sideCarTypes.map(
                                                  (element) => (
                                                    <option
                                                      key={element.value}
                                                      value={element.value}

                                                    >
                                                      {element.text}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            ) : (
                                              <input
                                                type="text"
                                                className="form-control"
                                                disabled={true}
                                                value="N/A"
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      {errors.settingsInfo?.sidecarmodeltype && (
                                        <p className="text-danger text-end pe-2">
                                          {errors.settingsInfo.sidecarmodeltype.message}
                                        </p>
                                      )}
                                      <div className="add-numbermain">
                                        <div >
                                          {t("NoOfSideCars")}
                                        </div>
                                        <div className="d-flex w-30">
                                          <div className="phoneselect w-100">
                                            <input
                                              type="text"
                                              className="form-control"
                                              name={`settingsInfo.noofsidecarsadded`}
                                              {...register(
                                                "settingsInfo.noofsidecarsadded",
                                                {
                                                  validate: sidecarsValidation,
                                                }
                                              )}
                                              onChange={(e) => {
                                                setValue(
                                                  "settingsInfo.noofsidecarsadded",
                                                  e.target.value,
                                                  { shouldDirty: true }
                                                );
                                                let validationError =
                                                  sidecarsValidation(e.target.value);
                                                if (validationError == false) {
                                                  setError(
                                                    "settingsInfo.noofsidecarsadded",
                                                    {
                                                      type: "manual",
                                                      message:
                                                        "Maximum allowed SideCars for this device is " +
                                                        autoDeviceDetails?.maxsidecarno,
                                                    }
                                                  );
                                                } else {
                                                  clearErrors(
                                                    "settingsInfo.noofsidecarsadded"
                                                  );
                                                }
                                              }}
                                            />
                                            {errors.settingsInfo?.noofsidecarsadded
                                              ?.type == "manual" && (
                                                <p className="text-danger">
                                                  {
                                                    errors.settingsInfo
                                                      ?.noofsidecarsadded?.message
                                                  }
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  }

                                  {/* Enable disable paging groups checkbox  */}
                                  {autoDeviceDetails.is_paging_support !== 0 && (
                                    <div className="add-numbermain">
                                      <div>
                                        {t("PagingGroups")}
                                      </div>
                                      <div className="d-flex">
                                        <div className="phoneselect ">
                                          <label className="switch">
                                            <input
                                              className="form-control"
                                              name="enablePaging"
                                              type="checkbox"
                                              checked={isEnabledPaging}
                                              onChange={(e) => handleCheckboxChange(e)}
                                            />
                                            <span className="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {/*enablePaging Contains true or false Boolean values , it will show or hide paging groups : Ganesh */}
                                  {isEnabledPaging && (
                                    <div>
                                      <div className="d-flex align-items-center justify-content-end">
                                        <MDBBtn
                                          className="mt-2"
                                          onClick={ToggleAddPagingGroup}
                                          disabled={pagingGroupsListdata.length === sel_data.length}
                                        >
                                          <MDBIcon fas icon="plus" className="me-2" />
                                          {t("AddPagingGroup")}
                                        </MDBBtn>
                                      </div>
                                      <div className="addPagingGroup-Data-table">
                                        <MDBDatatable className="actioncolumn"
                                          pagination={true}
                                          data={PagingGroupData}
                                        />
                                      </div>
                                    </div>
                                  )}



                                </section>
                                <div className="routing-border p-0"></div>
                                <section ref={section2} id='section-2'>

                                  <div class="general-settings" id="911settings">
                                    {t("emergency911")}
                                  </div>
                                  <div className="add-numbermain">
                                    <div>
                                      {t("Select")} {t("an")} {t("emergency911")}{" "}
                                      {t("location")}
                                    </div>
                                    <div className="d-flex w-30">
                                      <div className="phoneselect w-100">
                                        {/* <input
                                      type="text"
                                      className="form-small"
                                      name={`settingsInfo.location`}
                                      {...register("settingsInfo.location", {
                                        required: {
                                          value: true,
                                          message: "Location canot be empty",
                                        },
                                      })}
                                    /> */}
                                        <MDBSelect
                                          className="w-100"
                                          data={locationsInfo}
                                          search
                                          // searchFn={customSearchFn}
                                          placeholder="Select 911 Location"
                                          // value={getValues(
                                          //   "settingsInfo.location"
                                          // )}
                                          // onChange={(e) =>
                                          //   handleLocation(e.value)
                                          // }
                                          value={getValues(
                                            "settingsInfo.profileId"
                                          )}
                                          onChange={(e) => {
                                            if (e && e.value) {
                                              setValue("settingsInfo.profileId", parseInt(e.value), { shouldDirty: true });
                                            }
                                          }
                                          }
                                        />

                                        {/* {formErrors.locationError && (
                                        <span style={{ color: "red" }}>
                                          {formErrors.locationError}
                                        </span>
                                      )} */}
                                      </div>
                                    </div>
                                  </div>
                                </section>
                              </div>


                            </div>
                          </MDBCol>
                        </div>
                      </MDBTabsPane>
                      {showAddDevicePopup && (
                        <ShowAddDevicePopup
                          replaceDeviceInfo={autoDeviceDetails}
                          onClosePopup={closePopup}
                          showDevicePopup={setShowAddDevicePopup}
                        />
                      )}
                      {acdActive === "bulkloginlogout" && (
                        <MDBTabsPane open={acdActive === "bulkloginlogout"}>
                          {/* Bulk Login or Logout content */}
                          <AutoDeviceButtons deviceInfo={autoDeviceDetails} setEdited={setEdited} />
                        </MDBTabsPane>
                      )}
                    </MDBTabsContent>

                    {AddPagingGroup && (
                      <PopupLoader
                        size="md"
                        className="modal-md"
                        title={t("AddPagingGroup")}
                        content={
                          <AddPagingGroupInAutoDeviceSettingsPopup
                            onClose={ToggleAddPagingGroup}
                            pagingGroups={pagingGroupsListdata}
                            existPagingList={sel_data}
                            onSave={AddPagingGroupsRequest}
                          />
                        }
                        onShow={setAddPagingGroup}
                        onClose={ToggleAddPagingGroup}
                      />
                    )}

                    <MDBModal
                      open={pagingGroupModal}
                      setShow={setPagingGroupModal}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddPagingGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow2}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="tel-numbers">
                              <strong>{t("PagingGroupName")}</strong>
                            </div>
                            <div className="form pt-1">
                              <input
                                type="text"
                                className="form-control"
                                value="Backoffice"
                              />
                            </div>

                            <div className="tel-numbers pt-2">
                              <strong>{t("GroupID")}</strong>
                            </div>
                            <div className="form pt-1">
                              <input
                                type="text"
                                className="form-control"
                                value="4"
                              />
                            </div>
                          </MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow2}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBModal
                      open={replaceDevice}
                      setShow={setReplaceDevice}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("replaceDevice")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow7}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            {t("replace")} Nick Leyendecker IP Phone 1
                          </MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow7}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>
                  </div>
                </div>
              </section>
            </>
          }
        />
        <>
          {isDirty && (
            <SaveChanges
              onClose={onCloseChanges}
              onSave={(e) => {
                e.preventDefault();
                handleSubmit(onSubmit)();
              }}
            />
          )}

          {
            pagingDisable && (
              <ShowPagingDisablePopup
                onclosepopup={() => setpagingDisable(!pagingDisable)}
              // setshow={setpagingDisable}
              // paramJo={unAssignPhoneJo}
              />
            )
          }

          {
            isloading && (
              <div>
                <div className="loadingclass-popup"></div>
                <div className="popup-bg-loader loader_align">
                  <MDBBtn disabled>
                    <MDBSpinner
                      size="sm"
                      role="status"
                      tag="span"
                      className="me-2"
                    />
                    Loading...
                  </MDBBtn>
                </div>
              </div>
            )
          }
          {updatesuccessMessage && (
            <MDBAlert
              open
              className="alert-center"
              color="success"
              autohide
              position="bottom-right"
              delay={10000}
            >
              <i className="fas fa-check-circle me-3"></i>
              <span className="alert-msg">{updatesuccessMessage}</span>
            </MDBAlert>
          )}
          {isError && (
            <MDBAlert
              open
              className="alert-center"
              color="danger"
              autohide
              position="bottom-right"
              delay={100000}
            >
              {errorMessage}
            </MDBAlert>
          )}
          {showNoGroupAlert && (
            <MDBAlert
              open
              className="alert-center"
              color="danger"
              autohide
              position="bottom-right"
              delay={100000}
            >
              {t("pagingGroup_Error")}
            </MDBAlert>
          )}
          {showWarning && (
            <EditWarning
              warningToggle={warningToggle}
              setShowWarning={setShowWarning}
              onOk={handleOk}
            />
          )}
        </>
        {/* <Footer /> */}
      </>
    </React.Fragment >
  );
}

function ShowAddDevicePopup(props) {
  console.log(props);
  return (
    <>
      <PopupLoader
        title={props.replaceDeviceInfo ? "Replace Device" : "Add Device"}
        content={
          <AddDevices
            replaceDeviceInfo={props.replaceDeviceInfo}
            onClose={(e) => props.onClosePopup()}
          />
        }
        onShow={props.showDevicePopup}
        onClose={props.onClosePopup}
      />
      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
        Remove
      </Tooltip>
    </>
  );
}

export default IpphonesAddDevice;
